import { Routes } from '@angular/router';

import { AuthGuard } from '../auth.guard';
import { RootComponent } from '../root/root.component';
import { ListComponent } from './list/list.component';
import { ExportInvoicesComponent } from './export-invoices/export-invoices.component';


export const routing: Routes = [
  {
    path: 'export',
    data: {
      breadcrumb_en: 'Exports',
      breadcrumb_es: 'Exports'
    },
    component: RootComponent, canActivate: [AuthGuard],

    children: [
      {
        path: '', component: ListComponent,
        data: {
          breadcrumb_en: 'Export List',
          breadcrumb_es: 'Export List'
        },
      },
      {
        path: 'invoices', component: ExportInvoicesComponent,
        data: {
          breadcrumb_en: 'Invoices Export',
          breadcrumb_es: 'Invoices Export'
        },
      },
    ]

  }
];
